import { useHttpsCallable } from "react-firebase-hooks/functions";
import { useState } from "react";
import { functions } from "@poseidon/firebase/firebase";

export const useMakePayment = () => {
  const [executeCallable, saving, error] = useHttpsCallable(
    functions,
    "makePayment"
  );
  const [complete, setComplete] = useState(false);
  const makePayment = async (agreementId, scheduleId, paymentId) => {
    setComplete(false);
    try {
      await executeCallable({ agreementId, scheduleId, paymentId });
      setComplete(true);
    } catch (err) {
      setComplete(false);
    }
  };
  return { saving, error, success: !saving && !error && complete, makePayment };
};
